var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-button',{attrs:{"color":"success","type":"filled","disabled":_vm.disabled},on:{"click":_vm.compute}},[_vm._v("\n  "+_vm._s(_vm.disabled ? 'Przeliczanie Wykonane' : 'Przelicz klauzule')+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }